import React, { useEffect, useState } from 'react'
import { msgid, ngettext, t } from 'ttag'
import moment from 'moment/moment'
import { GoalWithProgress } from '../../services/api.types'
import { currentLangString, isRtl } from '../../i18nInit'
import { convertUTCToLocalDate, getShortDateString } from '../../common/helpers/date'
import { PluginListenerHandle } from '@capacitor/core'
import { App } from '@capacitor/app'
import makeStyles from '@material-ui/core/styles/makeStyles'

export interface IChallengeRankingProps {
  goal?: GoalWithProgress
  className?: string
  noMargin?: boolean
}

const useStyles = makeStyles((theme) => ({
  wrapper: {
    textAlign: 'center',
    overflow: 'hidden',
  },
  title: {
    fontWeight: 700,
    fontSize: '17px',
    lineHeight: '20px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}))

export default function YumChallengeTitle(props: IChallengeRankingProps) {
  const { goal, className, noMargin } = props
  if (!goal) return <></>

  const classes = useStyles()
  const { title, startDate, endDate } = goal

  const getRelativeTime = () => {
    if (convertUTCToLocalDate(new Date(endDate)).getTime() < new Date().getTime()) {
      const challengeEndDate = getShortDateString(endDate)
      return t`Ended ${challengeEndDate}`
    } else if (convertUTCToLocalDate(new Date(startDate)).getTime() > new Date().getTime()) {
      const challengeStartDate = getShortDateString(startDate)
      return t`Starts ${challengeStartDate}`
      // const daysToGo = moment(new Date(startDate)).diff(convertUTCToLocalDate(new Date()), 'days')
      //return daysToGo === 0 ? t`Starts tomorrow` : daysToGo === 1 ? t`1 day to go` : t`${daysToGo} days to go`
    } else {
      const daysLeft = moment(convertUTCToLocalDate(new Date(endDate))).diff(new Date(), 'days')
      return daysLeft === 0 ? t`Last day` : daysLeft === 1 ? t`1 day left` : t`${daysLeft} days left`
    }
  }

  const [relativeTime, setRelativeTime] = useState(getRelativeTime())

  let appStateChangeListener: PluginListenerHandle
  useEffect(() => {
    let oldRelativeTime = relativeTime
    const addListener = async () => {
      appStateChangeListener = await App.addListener('appStateChange', async ({ isActive }) => {
        if (isActive) {
          // Check if time has changed.
          const newRelativeTime = getRelativeTime()
          if (oldRelativeTime !== newRelativeTime) {
            setRelativeTime(newRelativeTime)
            oldRelativeTime = newRelativeTime
          }
        }
      })
    }
    addListener().catch(console.error)

    return () => {
      appStateChangeListener?.remove()
    }
  }, [])

  return (
    <div
      className={[classes.wrapper, className].join(' ')}
      style={{
        marginLeft: noMargin ? '0' : isRtl ? '10px' : '20px',
        marginRight: noMargin ? '0' : isRtl ? '20px' : '10px',
      }}
    >
      <div className={classes.title}>{title}</div>
      <div>{relativeTime}</div>
    </div>
  )
}
